import * as React from "react";
import { FieldProps } from "./props";
import "./autocomplete.scss";
import { Lead, getLeadTitle, DateFormats } from "../../../core";
import { isObject } from "util";
import moment from "moment";

const VersionAutoCompleteInput: React.FunctionComponent<FieldProps> = (
  props
) => {
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<any | undefined>(
    props.defaultValue || undefined
  );

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    const id = isObject(props.defaultValue)
      ? props.defaultValue?._id
      : props.defaultValue;

    if (id && id !== selectedItem?._id) {
      setSelectedItem(props.list?.find((x) => x._id === id));
    }
  }, [props.defaultValue]);

  React.useEffect(() => {
    if (props.defaultValue) {
      const id = isObject(props.defaultValue)
        ? props.defaultValue?._id
        : props.defaultValue;

      if (id && id !== selectedItem?._id) {
        setSelectedItem(props.list?.find((x) => x._id === id));
      }
    }
  }, [props.list]);

  const clickDropDown = () => {
    setShowDropDown(!showDropDown);
  };

  const handleSelect = (item: Lead) => {
    setSelectedItem(item);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(item);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  return (
    <React.Fragment>
      <div className="custom-dropdown position-relative" ref={wrapperRef}>
        <div
          onClick={clickDropDown}
          className="text-lg-left align-items-center border cursor-pointer custom-dropdown__value d-flex font-normal font-weight-semibold pb-3 pt-2 pt-3"
        >
          {selectedItem && props.defaultValue ? (
            <>
              <div className="flex-fill ml-1 text-muted ">
                Version{" "}
                {selectedItem?.versionNumber ||
                  (props.isLandlordCopy
                    ? selectedItem?.seperateDocumentForLandlord?.versionNumber
                    : selectedItem?.document?.versionNumber)}
              </div>
            </>
          ) : (
            <div className="custom-dropdown__value-text flex-fill ml-1 text-muted text-truncate"></div>
          )}
        </div>
        {showDropDown && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-2 pt-0">
            {props.list?.map((item) => {
              return (
                <LeadAutoFillItem
                  lead={item}
                  onClick={(lead) => handleSelect(lead)}
                  isLandlordCopy={props.isLandlordCopy}
                ></LeadAutoFillItem>
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export const LeadAutoFillItem = (props: {
  lead: any;
  onClick?: (item: any) => void;
  isLandlordCopy?: boolean;
}) => {
  const item = props.lead;

  return (
    <div
      onClick={() => props.onClick?.(item)}
      className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
    >
      <div className="font-normal font-weight-semibold text-lg-left w-100">
        Version{" "}
        {item?.versionNumber ||
          (props.isLandlordCopy
            ? item?.seperateDocumentForLandlord?.versionNumber
            : item?.document?.versionNumber)}
      </div>
    </div>
  );
};

export default VersionAutoCompleteInput;
